import { __decorate } from "tslib";
// NPM
import { Component, Mixins } from "vue-property-decorator";
import simplebar from "simplebar-vue";
// SYSTEM1
import Loader from "../../../components/widgets/loader.vue";
import Layout from "../../layouts/main.vue";
import PageHeader from "@/components/page-header.vue";
import BaseMixer from "@/router/views/BaseMixer";
import { setInteractionMode } from "vee-validate";
import DeleteComponent from "@/components/deleteComponent.vue";
import { interpret } from "xstate/lib/interpreter";
import EcGrid from "@/components/widgets/EcGrid.vue";
import categoryMachine from "./machines/categoryMachine";
import { CategoryModule } from "@/store/modules/categories.module";
import CategoryUpsertComponent from "./components/CategoryUpsertComponent.vue";
import { CategoryModel } from "@/store/models/categories/categoryDTO";
import { CategoryConstant } from "@/store/categoryConstant";
setInteractionMode("passive");
Component.registerHooks(["metaInfo"]);
let CategoriesListing = /** @class */ (() => {
    let CategoriesListing = class CategoriesListing extends Mixins(BaseMixer) {
        constructor() {
            super(...arguments);
            this.title = "Categories";
            this.machine = categoryMachine;
            this.machineService = interpret(this.machine, { devTools: true });
            this.state = this.machine.initialState;
            this.isGridLoading = false;
            this.initialPage = 1;
            this.initialPageSize = 10;
            this.totalCount = 0;
            this.categoryId = "";
            this.modalTitle = "";
            this.buttonName = "";
            this.deleteMessage = "";
            this.uncategorizedCategoryId = CategoryConstant.Uncategorized();
            this.hoveredCategory = new CategoryModel();
            this.editCategory = new CategoryModel();
            this.items = [
                {
                    text: "Home",
                    to: "/dashBoard",
                },
                {
                    text: "Masters",
                    href: "#",
                },
                {
                    text: "Categories",
                    active: true,
                },
            ];
            this.serverParams = {
                columnFilters: {},
                sort: {
                    field: "categoryName",
                    type: "asc",
                },
                page: 1,
                pageSize: 10,
            };
            this.columns = [
                {
                    field: "categoryName",
                    label: "Category Name",
                    thClass: "master-name",
                    sortable: true,
                    filterOptions: {
                        enabled: true,
                        autoComplete: "off",
                        placeholder: "Enter Category Name",
                    },
                },
                {
                    field: "description",
                    label: "Description",
                    thClass: "master-description",
                    sortable: false,
                },
                {
                    field: "exportSortOrder",
                    label: "Export Sort Order",
                    thClass: "text-center",
                    sortable: true,
                },
                {
                    field: "actions",
                    label: "Actions",
                    thClass: "master-action",
                    sortable: false,
                },
            ];
        }
        send(event) {
            this.machineService.send(event);
        }
        updateParams(newProps) {
            this.serverParams = Object.assign({}, this.serverParams, newProps);
        }
        onPageChange(params) {
            this.updateParams({ page: params.currentPage });
            this.loadItems();
        }
        onPerPageChange(params) {
            this.updateParams({
                pageSize: params.currentPerPage,
                page: this.initialPage,
            });
            this.loadItems();
        }
        onSortChange(params) {
            this.updateParams({ sort: params[0], page: this.initialPage });
            this.loadItems();
        }
        onColumnFilter(params) {
            this.updateParams({
                columnFilters: params.columnFilters,
                page: this.initialPage,
            });
            this.loadItems();
        }
        loadItems() {
            this.isGridLoading = true;
            var filters = [];
            Object.entries(this.serverParams.columnFilters).forEach(([key, value]) => {
                filters.push({
                    name: key,
                    value: value,
                });
            });
            var searchData = {
                page: this.serverParams.page,
                pageSize: this.serverParams.pageSize,
                sort: this.serverParams.sort,
                columnFilters: filters,
            };
            this.machineService.send({
                type: "GETTING_CATEGORY",
                searchData: searchData,
            });
        }
        onRowClick() {
            return "";
        }
        closeModal() {
            let categoryUpsert = this.$refs["showCategory"];
            categoryUpsert.hideModal();
        }
        stopLoading() {
            let categoryUpsert = this.$refs["showCategory"];
            categoryUpsert.stopLoading();
        }
        cancel() {
            this.send({
                type: "CANCEL_CATEGORY",
            });
        }
        AddCateogory() {
            this.modalTitle = "Add New Category";
            this.buttonName = "Save";
            let categoryUpsert = this.$refs["showCategory"];
            categoryUpsert.showModal(new CategoryModel());
            this.send({
                type: "ADDING_CATEGORY",
            });
        }
        EditCategory(id) {
            this.modalTitle = "Edit Category";
            this.buttonName = "Update";
            var editCategory = this.rows.find((a) => a.id == id);
            this.editCategory = { ...editCategory };
            this.send({
                type: "EDIT_CATEGORY",
            });
            let categoryUpsert = this.$refs["showCategory"];
            categoryUpsert.showModal(this.editCategory);
        }
        DeleteCategory(categoryId) {
            const isPageChanged = this.rows.length == 1 && this.serverParams.page != 1 ? true : false;
            const deleteCategory = this.rows.find((a) => a.id == categoryId);
            const entryCount = deleteCategory ? deleteCategory.entryCount : 0;
            this.deleteMessage = entryCount > 0 ? `This Category is associated with ${entryCount} ${entryCount === 1 ? "Entry" : "Entries"}, deleting it will not affect the ${entryCount === 1 ? "Entry" : "Entries"}.` : "";
            this.send({
                type: "DELETE_CATEGORY",
                ispageChanged: isPageChanged,
            });
            this.categoryId = categoryId;
        }
        DeletetingCategory() {
            this.send({
                type: "DELETING_CATEGORY",
                categoryId: this.categoryId,
            });
        }
        upsertCategory(category) {
            if (this.state.hasTag("showEditCategory")) {
                this.send({
                    type: "UPDATE_CATEGORY",
                    category: category,
                });
            }
            else {
                this.send({
                    type: "SAVE_CATEGORY",
                    category: category,
                });
            }
        }
        clearFilter() {
            this.serverParams.columnFilters = {};
            // this.serverParams.page = this.initialPage;
            var ecgrid = this.$refs.ecgrid;
            ecgrid.$refs.grid.$refs["table-header-primary"].$refs["filter-row"].columnFilters = {};
            this.loadItems();
        }
        saveEvent() {
            this.send({
                type: "ADDING_CATEGORY",
            });
        }
        upadateEvent() {
            this.send({
                type: "EDIT_CATEGORY",
            });
        }
        get rows() {
            return CategoryModule.categories;
        }
        get totalCategories() {
            return CategoryModule.totalCount;
        }
        get isAnyFilterApplied() {
            return this.columnFilters.length != 0 && this.columnFilters.some((x) => x.value);
        }
        get columnFilters() {
            var filters = [];
            Object.entries(this.serverParams.columnFilters).forEach(([key, value]) => {
                filters.push({
                    name: key,
                    value: value,
                });
            });
            return filters;
        }
        categoryDescPopover(value) {
            return value.length > 50 ? value : null;
        }
        created() {
            this.machineService.start();
            this.machineService.onTransition((state) => {
                var previousState = this.state;
                this.state = state;
                if (this.state.matches("loadedCategory")) {
                    this.totalCount = this.totalCategories;
                    this.isGridLoading = false;
                }
                if (this.state.matches("gettingCategory") && previousState.matches("deletingCategory")) {
                    this.isGridLoading = true;
                }
                if ((this.state.matches("gettingCategory") && previousState.matches("updateCategory")) || (this.state.matches("gettingCategory") && previousState.matches("savingCategory"))) {
                    this.stopLoading();
                    this.closeModal();
                }
                if (this.state.matches("loadedCategory") && previousState.matches("savingCategory")) {
                    this.stopLoading();
                    this.saveEvent();
                }
                if (this.state.matches("loadedCategory") && previousState.matches("updateCategory")) {
                    this.stopLoading();
                    this.upadateEvent();
                }
                if (this.state.matches("gettingCategory") && previousState.matches("deletingCategory")) {
                    if (this.state.context.ispageChanged) {
                        this.serverParams.page = this.serverParams.page - 1;
                    }
                }
            });
        }
        destroyed() {
            this.machineService.stop();
        }
    };
    CategoriesListing = __decorate([
        Component({
            name: "CategoriesListing",
            components: {
                DeleteComponent,
                Layout,
                Loader,
                PageHeader,
                simplebar,
                EcGrid,
                CategoryUpsertComponent,
            },
        })
    ], CategoriesListing);
    return CategoriesListing;
})();
export default CategoriesListing;
